import { immutableRecords } from "../../types";

export const findCardWithId = (cards, id) => {
  let foundCard = null;
  if (!cards) {
    return null;
  }
  cards.forEach(c => {
    if (c.id === id) {
      foundCard = c;
    } else {
      const c2 = findCardWithId(c.cards, id);
      if (c2) {
        foundCard = c2;
      }
    }
  });
  return foundCard;
};

export const globalRectForCardWithId = (cards, id, addX = 0, addY = 0) => {
  let foundRect = null;
  cards.forEach(c => {
    if (c.id === id) {
      foundRect = c.rect.toJS();
      foundRect.left += addX;
      foundRect.right += addX;
      foundRect.top += addY;
      foundRect.bottom += addY;
      foundRect = immutableRecords.FlatRectRecord(foundRect);
    } else {
      const r = globalRectForCardWithId(c.cards, id, addX + c.rect.left, addY + c.rect.top);
      if (r) {
        foundRect = r;
      }
    }
  });
  return foundRect;
};
